import './update-user.scss'

import { notification, Typography } from 'antd'
import axios from 'axios'
import { Formik, FormikHelpers } from 'formik'
import { Form, FormItem, Input, Select, SubmitButton, Switch } from 'formik-antd'
import { useState } from 'react'
import { Column } from 'react-display-flex'

import { filterProps, parseApiErrorResponse } from '../../../components/forms/utils'
import { messages } from '../../Tenants/messages'
import { UserFormValues, userStatuses, UserTableItem } from '../models'
import { validationSchema } from './validation'

export const UpdateUser = ({ user, onSuccess }: { user: UserTableItem; onSuccess: () => void }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const initialValues = getInitialValues(user)

  const onUpdateUser = async (userFormValues: UserFormValues, { setErrors }: FormikHelpers<UserFormValues>) => {
    setIsSubmitting(true)

    try {
      await axios.put(`/users/${user.id}`, userFormValues)

      notification.success({ message: messages.common.success, description: messages.user.updated })
      onSuccess()
    } catch (error) {
      setErrors(parseApiErrorResponse(error))

      notification.error({ message: messages.common.error, description: messages.user.updateError })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Column className="user-details" flexGrow>
      <Typography.Title level={3}>User Details</Typography.Title>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onUpdateUser}
        enableReinitialize
      >
        <Form name="update-user" className="update-user">
          <FormItem name="firstName" label="Name" required>
            <Input name="firstName" placeholder="Name" />
          </FormItem>
          <FormItem name="surname" label="Surname" required>
            <Input name="surname" placeholder="Surname" />
          </FormItem>
          <FormItem name="email" label="Email" required>
            <Input name="email" placeholder="Email" />
          </FormItem>
          <FormItem name="userStatus" label="Status" required>
            <Select
              name="userStatus"
              placeholder="Select the user status"
              showSearch
              popupClassName="capitalize"
              className="capitalize"
              options={userStatuses.map((status: string) => ({ label: status, value: status }))}
              {...filterProps}
            />
          </FormItem>
          <FormItem name="twoFactorAuthEnabled" label="Has 2FA enabled">
            <Switch checkedChildren="Yes" unCheckedChildren="No" name="twoFactorAuthEnabled" />
          </FormItem>
          <Column>
            <SubmitButton htmlType="submit" type="primary" disabled={isSubmitting}>
              Update User
            </SubmitButton>
          </Column>
        </Form>
      </Formik>
    </Column>
  )
}

const getInitialValues = ({ firstName, surname, email, userStatus, twoFactorAuthEnabled }: UserTableItem) => ({
  firstName,
  surname,
  email,
  userStatus,
  twoFactorAuthEnabled,
})
